import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const CalendarSmallIcon = createSvgIcon(
  <>
    <title></title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="4"
      transform="translate(0.5 0.5)"
    >
      <line
        data-cap="butt"
        fill="none"
        stroke="#222222"
        strokeLinecap="butt"
        strokeMiterlimit="10"
        x1="31"
        x2="1"
        y1="12"
        y2="12"
      />{' '}
      <rect
        fill="none"
        height="26"
        rx="3"
        ry="3"
        stroke="#222222"
        strokeMiterlimit="10"
        width="30"
        x="1"
        y="4"
      />{' '}
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="8"
        x2="8"
        y1="1"
        y2="7"
      />{' '}
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="24"
        x2="24"
        y1="1"
        y2="7"
      />
    </g>
  </>
)
